import { css } from 'styled-components';

const reactDatepicker = css`
  .react-datepicker-wrapper {
    display: flex;
  }
`;

export default reactDatepicker;
